import React from 'react';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import NavListItem from './NavListItem';

interface NavToggleProps {
    open: boolean;
    onToggle: () => void;
}

const NavToggle: React.FC<NavToggleProps> = ({ open, onToggle }) => {
    return (

        <NavListItem
            open={open}
            onClick={onToggle}
            iconElement={
                open
                    ? <KeyboardDoubleArrowLeftIcon className='nav-icon' />
                    : <KeyboardDoubleArrowRightIcon className='nav-icon' />
            }
            label='Close menu'
        />
    );
};
export default NavToggle;